import React, { useCallback } from 'react';
import { styled } from '@linaria/react';
import { Button } from '@vio/atlas/Button';
import { Card } from '@vio/atlas/Card';
import { Flex } from '@vio/atlas/helpers/Flex';
import { Icon } from '@vio/atlas/Icon';
import { Text } from '@vio/atlas/Text';
import { UploadStatus as UploadStatusType } from '../types/s3Upload';
interface Props {
  uploadStatus: UploadStatusType;
  onCopyUrl?: (url: string) => void;
}
const UrlContainer = /*#__PURE__*/styled('div')({
  name: "UrlContainer",
  class: "usjg2ft",
  propsAsIs: false
});
const UrlText = /*#__PURE__*/styled('code')({
  name: "UrlText",
  class: "uz2tnqo",
  propsAsIs: false
});
export const UploadStatus: React.FC<Props> = ({
  uploadStatus,
  onCopyUrl
}) => {
  const {
    isUploading,
    isSuccess,
    isError,
    message,
    result
  } = uploadStatus;
  const handleCopyUrl = useCallback(() => {
    if (result?.themeOverrideUrl && onCopyUrl) {
      onCopyUrl(result.themeOverrideUrl);
    }
  }, [result?.themeOverrideUrl, onCopyUrl]);
  const getStatusIcon = () => {
    if (isUploading) return <Icon name="Refresh3" />;
    if (isSuccess) return <Icon name="Check" />;
    if (isError) return <Icon name="Close" />;
    return null;
  };
  const getStatusColorPath = () => {
    if (isSuccess) return 'content.success.c600';
    if (isError) return 'content.danger.c600';
    return 'content.neutral.c600';
  };
  if (!isUploading && !isSuccess && !isError) {
    return null;
  }
  return <Card>
      <Flex.Row gap="s100">
        {getStatusIcon()}
        <Text variant="bodyS" colorPath={getStatusColorPath()}>
          {message}
        </Text>
      </Flex.Row>

      {isSuccess && result?.themeOverrideUrl && <UrlContainer>
          <Flex.Column gap="s100">
            <Text variant="bodyXS">Theme Override URL:</Text>
            <Flex.Row gap="s100">
              <UrlText>{result.themeOverrideUrl}</UrlText>
              <Button variant="secondary" size="sm" onClick={handleCopyUrl}>
                <Icon name="Copy" /> Copy
              </Button>
            </Flex.Row>
          </Flex.Column>
        </UrlContainer>}
    </Card>;
};

require("./UploadStatus.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./UploadStatus.tsx");